document.addEventListener('alpine:init', () => {
    Alpine.data('eventsList', () => ({
        isShow: false,

        showAll() {
            this.isShow = true
        }
    }));
});
